module.exports = __webpack_public_path__ + "media/images/illust01-d3cc71ed8c7e12dca770b3b44f6dd7ea.png";